export default "__VITE_ASSET__U2FrV8Rs__"